
    import {Options, Vue, Watch} from 'vue-property-decorator';
    import TooltipInfo from '@/brief-hub/common/ui/components/TooltipInfo.vue';
    import BriefHubStepLayout from '@/brief-hub/common/ui/layout/BriefHubStepLayout.vue';
    import {Getter} from 'vuex-class';
    import InputText from '@malt/joy-entrypoint/src/vue/InputText.vue';
    import type {BriefFreelancerJobTitle as FreelancerJobTitle, BriefFreelancerProfile, Payload} from '@/brief-hub/store/modules/brief/types';
    import {MutationsType} from '@/brief-hub/store/modules/brief/mutations';
    import {RouteLocationNormalized} from 'vue-router';

    @Options({
        components: {TooltipInfo, BriefHubStepLayout, InputText},
        beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: (vm: any) => void) {
            next((vm: any) => {
                vm.onFormChange();
            });
        },
    })
    export default class BriefFreelancerJobTitle extends Vue {
        @Getter('briefFreelancerProfile')
        briefFreelancerProfile!: BriefFreelancerProfile;

        @Getter('briefFreelancerJobTitle')
        briefFreelancerJobTitle!: FreelancerJobTitle;

        private minLength = 6;
        private maxLength = 120;
        private jobTitle = '';

        created(): void {
            this.$requireMsg('customer.brief.form.freelancer.profile.job.title.placeholder.*');
            this.jobTitle = this.briefFreelancerJobTitle.jobTitle || '';
        }

        get placeholder(): string {
            const base = 'customer.brief.form.freelancer.profile.job.title.placeholder';
            const familyId = this.briefFreelancerProfile.selectedFamily;

            const key = `${base}.${familyId}`;
            const msg = this.$msg(key);

            return msg === key ? this.$msg(`${base}.default`) : msg;
        }

        get isMinValid(): boolean {
            return this.jobTitle?.length > this.minLength || false;
        }

        get isMaxValid(): boolean {
            return this.jobTitle?.length < this.maxLength || false;
        }

        get jobTitleValidation(): boolean {
            return this.isMinValid && this.isMaxValid;
        }

        get showJobTitleError(): boolean {
            return !!this.jobTitle?.length && !this.jobTitleValidation;
        }

        @Watch('jobTitle')
        onFormChange(): void {
            let payload: Payload | null = null;
            if (this.jobTitleValidation) {
                payload = {
                    type: 'FreelancerJobTitleBriefRequest',
                    payload: {
                        jobTitle: this.jobTitle,
                    },
                };
            }
            this.$store.commit(MutationsType.UPDATE_PAYLOAD, payload);
        }
    }
